import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { ActionBar } from '../../models';

@Component({
    selector: 'app-action-bar',
    templateUrl: './action-bar.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ActionBarComponent {
  @Input() actionBar!: ActionBar;

  constructor() {}
}
